"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_action_1 = require("./base.action");
var close_reason_model_1 = require("../../models/close-reason.model");
var CloseInvitationAction = /** @class */ (function (_super) {
    __extends(CloseInvitationAction, _super);
    function CloseInvitationAction(invitationService, notificationService) {
        var _this = _super.call(this) || this;
        _this.invitationService = invitationService;
        _this.notificationService = notificationService;
        // Subscribe to chat state notifications.
        _this.notificationService.chatState$.subscribe(function (isChatOpen) {
            _this.isChatOpened = isChatOpen;
        });
        return _this;
    }
    CloseInvitationAction.prototype.act = function () {
        if (this.isChatOpened) {
            console.log('No invitation auto close, as invitation was already closed.');
        }
        else {
            console.log('Automatic invitation close.');
            this.invitationService.hideInvitation(close_reason_model_1.CloseReason.Auto);
        }
    };
    return CloseInvitationAction;
}(base_action_1.BaseAction));
exports.CloseInvitationAction = CloseInvitationAction;
